export default __webpack_public_path__ + "6796a18bef6117b187a791b73de519df.png";